export default defineNuxtPlugin(async () => {
  const { getCartOrCreate } = useCart();
  const isAuthenticated = computed(() => useCookie('isAuthenticated').value);

  const params: any = {
    currency: 'EUR',
    pageable: { page: 0, size: 10 },
    status: ['INIT', 'LOADING', 'ON_GOING'].join(','), // Convert the array to a comma-separated string
  };

  try {
    isAuthenticated.value ? await getCartOrCreate(params, true) : null;
  } catch (error) {
    console.error('Error while fetching or creating the cart:', error);
  }
});
